export const primaryColor = "#b685ff";
export const secondaryColor = "#101011";
export const textWithWhiteBg = "#101011";
export const textWithPrimaryColorBg = "#101011";
export const linearGradient =
  "linear-gradient(108deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 36.65%, rgba(183, 133, 255, 0.60) 78.17%, rgba(183, 133, 255, 0.60) 124.19%)";
